import "../../../assets/scss/login.scss";
import { ApiRoutes } from "../../../core/dictionary/api-url";
import AllLogin from "../../common/all-login";

export default function CoachTeamMemberLogin() {
  const coachTeamMemberLoginConfig = {
    rightSectionHeading: "RESUSCITATION TRAINING THAT BUILDS CONFIDENCE.",
    rightSectionSubHeading: "Code Blue Readiness for Teams That Save Lives.",
    leftCardHeading: "Coach & Team Member Login",
    apiEndpoint: ApiRoutes.LOGIN_COACH_TEAM_MEMBER,
    loginType: "coach-team-member-login",
    nextNavigationPath: "/dashboard",
  };
  return <AllLogin config={coachTeamMemberLoginConfig}></AllLogin>;
}
